export enum ServiceStatus {
  UP = 'UP',
  IMPAIRED = 'IMPAIRED',
  ON_BACKUP = 'ON BACKUP',
  DOWN = 'DOWN',
}

export const SERVICE_STATUS_BY_SEVERITY = Object.freeze([
  ServiceStatus.DOWN,
  ServiceStatus.ON_BACKUP,
  ServiceStatus.IMPAIRED,
  ServiceStatus.UP,
]);

export const SERVICE_STATUS_COLORS = Object.freeze({
  [ServiceStatus.UP]: '#3dcc64',
  [ServiceStatus.IMPAIRED]: '#ffbb2c',
  // Distinct from IMPAIRED's amber — ON_BACKUP means running on a fallback
  // circuit, not a fault, so it shouldn't share the "warning" color. Purple
  // matches this app's existing `purple` palette (tailwind.config.js),
  // already used for a similar "notable, not an error" state (iq.investigate).
  [ServiceStatus.ON_BACKUP]: '#8781FF',
  [ServiceStatus.DOWN]: '#ef4732',
});

export const DEFAULT_SERVICE_STATUS_COLOR =
  SERVICE_STATUS_COLORS[ServiceStatus.UP];
